import React from 'react';

import { IPageContext } from '../../interfaces/pagecontext.interface';

interface Props {
  buttonData: {
    Text: string;
    Link: string;
  };
  pageContext: IPageContext;
}

const ContactUs = ({ buttonData, pageContext }: Props) => {
  const { marketingSiteUrl } = pageContext;

  return (
    <a className="main-navigation-link link-button" href={`${marketingSiteUrl}/${buttonData.Link}`}>
      {buttonData.Text}
    </a>
  );
};

export default ContactUs;
